<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

    <template>
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">
              {{ $t("view_qr") }}</v-tab
            >

            <v-tab :ripple="true"> {{ $t("preview") }}</v-tab>
            <v-tab :disabled="e6 <= 1" :ripple="true"> تعرفه‌ها </v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" />
              <div class="rowinfo">
                <v-btn
                  class="btn-download contnetinfo"
                  @click="showDialog = true"
                >
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-downloadQr`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  class="buttoninfo"
                  :label="$t('download_qr')"
                />
              </div>
            </v-tab-item>

            <v-tab-item>
              <component
                :is="theme"
                v-model="cardTexts"
                :components.sync="specialInfo"
                :ordered.sync="ordered"
                :qr-svg-data-url="qrSvgDataUrl"
              />
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'VisitCard'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>{{ $t("enter_product_information") }}</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    :label="'معرفی محصول پرو'"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :help-data="helpData"
                    :service-name="serviceName"
                    class="buttoninfo"
                    :label="$t('product_name_short')"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    :help-data="helpData"
                    :service-name="serviceName"
                    class="buttoninfo"
                    :label="$t('qr_address')"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <!-- <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
              {{ $t('complete_features_from_image') }}
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <image-to-text-inf-ai
                ref="imageToText"
                @save="
                  (e) => {
                    cardTexts.singleProduct.description = e;
                    qrUpdate(false);
                    e6++;
                  }
                "
              />

              <div class="col-md-12">
                <v-btn depressed @click="e6++"> {{ $t('skip_step') }} </v-btn>
                <next-btn
                  v-if="!!$refs.imageToText"
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="$refs.imageToText.setInfo"
                />
              </div>
            </v-stepper-content> -->

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">{{
              $t("product_and_information")
            }}</v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="d-flex row mx-0 mt-2">
                <v-btn
                  :disabled="e6 > 2"
                  class="mb-4"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  {{ $t("remove_default_info") }}
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-clearDefaults`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  :label="$t('remove_default_info')"
                />
              </div>
                                <div class="mb-4 mx-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>
              <list-expansion
                :component-name="componentName"
                :serice-name="serviceName"
                flat
                icon="pencil-ruler"
                single
                :title="$t('select_template_design')"
                @save-required="AutoSave && qrUpdate(false)"
              >
                <template v-slot:content>
                  <theme-selector2
                    v-model="theme"
                    :components="customTheme"
                    :frames="picFrames"
                  />
                </template>
              </list-expansion>
              <list-expansion
                v-model="cardTexts"
                :component-name="componentName"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              v-if="e6 > 1"
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              :label="$t('download_qr')"
            />
          </template>
          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
              :qr_id="info.qrId"
              :visit-name="cardTexts.visitName"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize.vue";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import NewProCard from "@/view/components/Product/newProCard";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import newDesign from "@/view/pages/product/newDesign";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import ImageToTextInfAi from "@/view/components/adapters/AIGeneration/imageToTextInfAi.vue";
import { mapActions } from "vuex";
import feedbackMobileView from "../otherQrTypes/feedBack/components/feedbackMobileView.vue";
import consultationQrView from "../otherQrTypes/consultationQr/components/consultationQrView.vue";
import DownloadFileWithApi from "../qrland/downloadFileWithApi.vue";
import Tariffs from "../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "productPro",

  components: {
    ImageToTextInfAi,
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    newDesign,
    ThemeSelector2,
    ProductTheme2,
    NewProCard,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    DownloadFileWithApi,
    QrCustomize,
    QrMaker,
    QrGenerator,
    feedbackMobileView,
    consultationQrView,
    Tariffs,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
      ordered: [],
      helpData: [],
      serviceName: "Qrland",
      componentName: "productPro",
      theme: "newDesign",
      qrDesign: {},
      cons: { title: this.$t("download_qr") },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      picFrames: [
        { name: "newProCard", src: "/media/frame/themes/2.svg" },
        { name: "productTheme2", src: "/media/frame/themes/t2.webp" },
        { name: "newDesign", src: "/media/bg/product.webp" },
      ],
      customTheme: [
        { name: "newProCard", value: "" },
        { name: "productTheme2", value: "" },
        { name: "newDesign", value: "" },
      ],
      finish: true,
      loading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "factoryInfo",
          value: "",
          title: "اطلاعات مجموعه",
          subtitle: "",
          icon: "account-outline",
          secondName: "اطلاعات مجموعه",
          iconColor: "#5C6BC0",
          src: "/media/productpro/factoryInfo.gif",
        },

        {
          name: "singleProductEditor",
          value: "",
          title: "اطلاعات محصول",
          subtitle: "",
          icon: "information-outline",
          model: "singleProduct",
          secondName: "اطلاعات محصول",
          iconColor: "#26A69A",
          src: "/media/productpro/Features.gif",

          tabs: [
            {
              title: "نشان اعتماد",
              icon: "mdi-image",
              component: "ArmsChooser",
              model: "arm",
              iconColor: "#4BBAEE",
            },
            {
              title: "دکمه خرید",
              icon: "mdi-button-cursor",
              component: "CallToAction",
              model: "btnSetting",
              iconColor: "#A75CEE",
            },
          ],
        },

        {
          name: "customerClubSettings",
          value: "",
          title: "پیامک عضویت در باشگاه مشتریان",
          subtitle: "",
          icon: "cellphone-message",
          model: "customerClub",
          iconColor: "#A66026",
          src: "/media/productpro/qr.gif",
        },

        {
          name: "Features",
          value: "",
          title: "افزودن ویژگی محصول",
          subtitle: "",
          icon: "information-outline",
          model: "Features",
          secondName: "ویژگی های محصول",
          iconColor: "#8C26A6",
          src: "/media/productpro/singleProduct.gif",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "message-reply-text-outline",
          model: "FeedBack",
          secondName: " بازخورد",
          iconColor: "#42A5F5",
          src: "/media/productpro/feedback.gif",
        },
        {
          name: "consultationNew",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "form-select",
          model: "consultationNew",
          secondName: " فرم درخواست",
          iconColor: "#FF7043",
          settings: {
            notColor: true,
          },
          src: "/media/productpro/form.gif",
        },
        {
          name: "advanceSettings",
          title: "تنظیمات هوشمند",
          icon: "star-settings-outline",
          model: "advanceSettings",
          iconColor: "#A6266C",
          src: "/media/productpro/advanceSettings.gif",
        },
        {
          name: "voiceGallery",
          title: "افزودن فایل صوتی",
          icon: "microphone",
          model: "audiosGallery",
          secondName: "گالری صوتی",
          iconColor: "#A6264C",
          src: "/media/productpro/voice.gif",
        },

        {
          name: "imageUploader",
          value: "",
          title: "افزودن تصویر",
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
          secondName: "گالری عکس",
          iconColor: "#2659A6",
          src: "/media/productpro/imageGallery.gif",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          secondName: "گالری ویدئو",
          subtitle: "",
          icon: "video-outline",
          iconColor: "#A6269B",
          src: "/media/productpro/VideoGallery.gif",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
          secondName: "شبکه های اجتماعی",
          iconColor: "#A4A626",
          src: "/media/productpro/instagram.gif",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
          iconColor: "#26A637",
          src: "/media/productpro/imageGallery2.gif",
        },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      dtUrl: null,
      domainId: null,
      cardTexts: {
        cardSettings: {
          sizeLevel: 1,
        },
        audiosGallery: {
          audios: [],
          audioType: "newPlayer",
        },
        advanceSettings: {
          viewConfigs: {
            autoCsvDownload: false,
            showCClubOnload: false,
            forcedSubmission: "optional",
          },
          hasManifestIcons: false,
          hasAssistants: false,
          aiChatConfig: {
            assistantId: null,
            assistant: null,
            hasAssistants: false,
            hasAssistantsName: false,
            hasAssistantsFamily: false,
            hasAssistantsMobile: false,
            chatSettings: {
              headerColor: "#667eea",
              headerColor2: "#764ba2",
              headerGradient: true,
              backgroundColor: "#ffffff",
              backgroundImage: null,
              useImageBackground: false,
              textColor: "#333333",
              fontSize: 14,
              chatLogo: null,
              floatingIcon: "mdi-robot",
              useImageLogo: false,
            },
          },
          manifest: {
            icon48: "",
            icon144: "",
            screenshotWide: "",
            screenshot600: "",
          },
        },
        customerClub: {
          configs: {
            isActive: true,
            smsType: "pattern",
            patternId: 487,
          },
        },

        pallete: {
          headColor: "linear-gradient(to top left , #00BCD4FF, #2F0743FF)",
          bodyColor: "linear-gradient(to top left , #006064FF, #03A9F4FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        },
        FeedBack: {
          title: "بازخورد شما",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
          sectionColor: {
            backGround: "linear-gradient(to right , #EB5A3C, #E5989B)",
            text: "#fff",
          },
          type: "text",
          items: [
            {
              question: "چقدر از خدمات کیوآرلند راضی بوده اید؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "خدمات کیوآرلند چه میزان از نیازهای شما را پوشش داده است؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "میزان هزینه پرداختی بابت سرویس دریافتی چقدر معقول بوده است؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "برای  بهبود خدمات نظر خود را با ما درمیان بگذارید.",
              answer: "",
              value: null,
              description: true,
              forceDesc: false,
            },
          ],
        },

        consultationNew: {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        },

        banner: {
          images: [
            {
              title: "WhatsApp Image 2022-06-08 at 4.01.18 PM(2)",
              url: "https://cdn.terminalads.com/upload/63fb1ed3aaa06.webp",
              description: "",
              link: "",
            },
            {
              title: "565089-dota-2-wallpaper",
              url: "https://cdn.terminalads.com/upload/645756ebac0ba.webp",
              description: "",
              link: "",
            },
            {
              title: "ali_larter_3-wallpaper-1600x900",
              url: "https://cdn.terminalads.com/upload/6457570fef1ea.webp",
              description: "",
              link: "",
            },
          ],
          name: "بنر",
        },
        photo: {
          background: "",
          headBackground: "",
          profile: "",
          transition: "scale",
          hasWelcome: false,
          hasGame: true,
          hasGif: true,
          previewerQr: {
            previewer: {
              gif: "",
              game: {
                type: "Game",
                count_play: 1,
                config: {
                  lives: 3,
                  pointsPerQR: 20,
                  spawnRateEnemy: 60,
                  spawnRateQR: 80,
                  minSpeed: 3,
                  maxSpeed: 7,
                  winThreshold: 500,
                  magnetThreshold: 200,
                  magnetDuration: 2000,
                },

                texts: {
                  titleText: "مأموریت کیوآرلند",
                  subtitleText: "کیوارها رو جمع کن و امتیاز بگیر",
                  startButtonText: "شروع بازی",
                  scoreLabel: "امتیاز",
                  gameOverText: "باتری گوشی تمام شد!",
                  gameOverSubtext: "دوباره شانس‌ت رو امتحان کن",
                  promptText: "برای شرکت در قرعه‌کشی شماره خود را وارد کنید",
                  submitText: "ثبت و ادامه",
                  title: "QRLand Runner",
                  funMessages: ["ایول!", "بپر!", "عالی بود"],
                },

                images: {
                  playerImage: "/media/defaults/player.png",
                  backgroundImage: "/media/defaults/game-bg.jpg",
                  enemyImages: ["/media/defaults/enemy1.png"],
                  powerupImage: "/media/defaults/magnet.png",
                  qrImages: ["/media/defaults/qr1.png"],
                  bgFar: "",
                  bgNear: "",
                },

                login: {
                  askPhone: true,
                  logoUrl: "/media/defaults/qr-logo.png",
                  promptText: "لطفا شماره موبایل خود را وارد کنید",
                  submitText: "ثبت",
                },
                effects: {
                  showParticles: true,
                  playSounds: true,
                  vibration: true,
                  particleColor: "#FF5722",
                },

                colors: {
                  background: "#588ffb",
                  ground: "#f8af5d",
                  hud: "rgba(0,0,0,0.75)",
                },

                gameplay: {
                  baseSpeed: 5,
                  maxSpeed: 15,
                  speedStep: 0.2,
                  jumpForce: -15,
                  lives: 3,
                  minScoreToSubmit: 100,
                },
              },
              transition: "scale",
            },
          },
        },

        Features: {
          show: "accordion",
          details: [
            {
              name: "ویژگی های محصول",
              showIt: false,
              value: [
                {
                  label: "",
                  value: "•سیستم میکروپروسسوری با دقت بالا (۰.۱ ثانیه)",
                  icon: "",
                  name: "",
                  link: "",
                },
                {
                  label: "",
                  value:
                    "•دارای نمایشگر •Time Value: زمان •Mode: حالت کاری •Rel: وصل رله",
                  icon: "",
                  name: "",
                  link: "",
                },
                {
                  label: "",
                  value:
                    "•دارای ۸ حالت مختلف کاری: تایمر: ۱. دهم ثانیه ۲. ثانیه ۳. دقیقه ۴. ساعت فلاشر: ۵. دهم ثانیه ۶ .ثانیه ۷. دقیقه ۸. ساعت",
                  icon: "",
                  name: "",
                  link: "",
                },
                {
                  label: "",
                  value: "•تعیین وضعیت رله (وصل یا قطع) در شروع زمان گیری",
                  icon: "",
                  name: "",
                  link: "",
                },
              ],
            },
          ],
        },
        singleProduct: {
          name: "سوپر تایمر دیجیتال",
          description:
            "سوپر تایمر دیجیتال شیوا امواج تایمری با دقت و کارآیی بسیار بالا و قابل استفاده در رنج وسیعی از محدوده زمانی (از ۰.۱ ثانیه تا ۹۹۹ ساعت) می باشد . همچنین این تایمر می تواند در ۴حالت دهم ثانیه ، ثانیه ، دقیقه و ساعت به صورت فلاشر کار کند . سوپر تایمر شیوا امواج را می توانید در ۲حالت تایمر تأخیر در قطع و تایمر تأخیر در وصل مورد استفاده قرار دهید . تغذیه این تایمر از ترمینال های START مجزا است و در ۲ مدل با تغذیهACو DC عرضه می شود .",
          price: 6915000,
          discount: "3",
          payLink: "",
          btnSetting: {
            title: "خرید",
            icon: undefined,
            background: "linear-gradient(to top left , #D81A1AFF, #2115A7FF)",
            color: "white",
          },
          extra: [
            {
              label: "",
              value: "",
              icon: "",
              name: "",
              link: "",
            },
          ],
          image: "",
          color: undefined,
          arm: [],
        },
        visitName: "معرفی محصول پرو", //TODO
        isGradient: false,
        organizationName: this.$t("shiva_waves"),
        subOrgan: this.$t("think_best"),
        userName: "",
        workField: "1373",
        phoneNumber: [
          { number: "09134034351", text: "" },
          { number: "09130363030", text: "" },
        ],
        extraFields: [{ icon: "", name: "", value: "" }],
        companyNumber: "03135723690",
        companyNumberName: "",
        email: "info@shivaamvaj.com",
        fax: "03135723400",
        location: "ایران ،زنجان،ابهر،شهرک صنعتی شریف ، جنب پست برق 63/20",
        city: "",

        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.shivaamvaj.com",
        socialMedia: {},
        aboutUs: "",
        // VideoGallerySingle: {
        //   "name": "",
        //   "videos": []
        // },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "از ویدئوهای مجموع ما دیدن فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        video_gallery: [
          {
            name: "گالری",
            images: [
              {
                name: "خوش آمدگویی",
                title: "",
                file_link:
                  "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
                description: "",
                link: "",
                id: 15,
              },
            ],
          },
        ],
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      destinationUrl: "",
      qrSvgDataUrl: "",
      info: null,
    };
  },
  provide: {
    provideSingleGallery: false,
  },
  computed: {
    backgroundUrl() {
      return this.$cdnUrl + "/upload/64b2bb1c4ad38.webp";
    },
    headBackground() {
      return this.$cdnUrl + "/upload/64b2abe4bab25.webp";
    },
    profileUrl() {
      return this.$cdnUrl + "/upload/64b2abe4bab25.webp";
    },

    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;

    this.cardTexts.photo.background = this.backgroundUrl;
    this.cardTexts.photo.headBackground = this.headBackgroundUrl;
    this.cardTexts.photo.profile = this.profileUrl;

    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },

    "cardTexts.photo.gallery": {
      deep: true,

      handler(val) {
        this.$root.$emit("rerenderSwiper");
      },
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error(this.$t("invalid_address"));
        return;
      }

      this.loading = true;
      let obj = {
        type: "productpro",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.setCreatedQrID(this.info.id);
          this.updateQrInfo(data.data);
          this.updateQridentifier(data.data.identifier);
          this.updateQrDomain(data.data.domain_id);
          this.updateQrId(this.info.id);
          this.$toast.success("کیوآر معرفی محصول پرو شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "productpro");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
          ordered: this.ordered || [],
        }),
      );
      data.append("qr", JSON.stringify(this.qrDesign));

      this.$api
        .post("/v1/testQr/update", data)
        .then((res) => {
          if (final || !this.AutoSave)
          this.$toast.success("کیوآر معرفی محصول پرو شما با موفقیت ویرایش شد.");
          final && this.goto("qr/list");
        })
        .catch((err) => {
          this.loading = false;
          this.isAutoSaving = false;
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.cardTexts.visitName = "";
      this.cardTexts.isGradient = false;
      this.cardTexts.organizationName = "";
      this.cardTexts.photo.previewerQr.previewer.gif = "";
      this.cardTexts.photo.previewerQr.previewer.game.config = {};
      this.cardTexts.subOrgan = "";
      this.cardTexts.userName = "";
      this.cardTexts.workField = "";
      this.cardTexts.phoneNumber = [{ number: "" }];
      this.cardTexts.extraFields = [
        {
          icon: "",
          name: "",
          value: "",
        },
      ];
      this.cardTexts.Features = {
        show: "accordion",
        details: [
          {
            name: "",
            showIt: false,
            value: [],
          },
        ],
      };
      this.cardTexts.companyNumber = "";
      this.cardTexts.email = "";
      this.cardTexts.fax = "";
      this.cardTexts.location = "";
      this.cardTexts.city = "";
      this.cardTexts.singleProduct = {
        name: "",
        description: "",
        price: 0,
        discount: "0",
        payLink: "",
        btnSetting: {
          title: "",
          icon: undefined,
          background: "linear-gradient(to top left , #D81A1AFF, #2115A7FF)",
          color: "white",
        },
        extra: [
          {
            label: "",
            value: "",
            icon: "",
            name: "",
            link: "",
          },
        ],
        image: "",
        color: undefined,
        arm: [],
      };
      this.cardTexts.photo = {
        gallery: [
          {
            name: "",
            images: [],
          },
        ],
        headBackground: "",
        background: "",
        profile: "",
        transition: "scale",
        hasWelcome: false,
        hasGame: true,
        hasGif: true,
        previewerQr: {
          previewer: {
            gif: "",
            game: {
              type: "Game",
              count_play: 1,
              config: {
                lives: 3,
                pointsPerQR: 20,
                spawnRateEnemy: 60,
                spawnRateQR: 80,
                minSpeed: 3,
                maxSpeed: 7,
                winThreshold: 500,
                magnetThreshold: 200,
                magnetDuration: 2000,
              },
              texts: {
                titleText: "مأموریت کیوآرلند",
                subtitleText: "کیوارها رو جمع کن و امتیاز بگیر",
                startButtonText: "شروع بازی",
                scoreLabel: "امتیاز",
                gameOverText: "باتری گوشی تمام شد!",
                gameOverSubtext: "دوباره شانس‌ت رو امتحان کن",
                promptText: "برای شرکت در قرعه‌کشی شماره خود را وارد کنید",
                submitText: "ثبت و ادامه",
                title: "QRLand Runner",
                funMessages: ["ایول!", "بپر!", "عالی بود"],
              },
              images: {
                playerImage: "/media/defaults/player.png",
                backgroundImage: "/media/defaults/game-bg.jpg",
                enemyImages: ["/media/defaults/enemy1.png"],
                powerupImage: "/media/defaults/magnet.png",
                qrImages: ["/media/defaults/qr1.png"],
                bgFar: "",
                bgNear: "",
              },

              login: {
                askPhone: true,
                logoUrl: "/media/defaults/qr-logo.png",
                promptText: "لطفا شماره موبایل خود را وارد کنید",
                submitText: "ثبت",
              },
              effects: {
                showParticles: true,
                playSounds: true,
                vibration: true,
                particleColor: "#FF5722",
              },

              colors: {
                background: "#588ffb",
                ground: "#f8af5d",
                hud: "rgba(0,0,0,0.75)",
              },

              gameplay: {
                baseSpeed: 5,
                maxSpeed: 15,
                speedStep: 0.2,
                jumpForce: -15,
                lives: 3,
                minScoreToSubmit: 100,
              },
            },
            transition: "scale",
          },
        },
      };
      this.cardTexts.codePostal = "";
      this.cardTexts.province = "";
      this.cardTexts.country = "";
      this.cardTexts.website = "";
      this.cardTexts.socialMedia = {};
      this.cardTexts.aboutUs = "";
      this.cardTexts.video_single = {
        name: "",
        videos: [],
      };
      this.cardTexts.center = [51.420296, 35.732379];
      this.cardTexts.coordinates = null;
      this.cardTexts.address = "";
      this.cardTexts.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
